/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CreditCardAmex/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CreditCardAmex({
  children,
  viewPath = "/DesignSystem/Svgs/CreditCardAmex",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 42,
  height = 42,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#fff",
  fill3 = "#006fcf"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="CreditCardAmex.Svg"
  data-view-path={viewPath}
 viewBox="0 0 42 42"
 fillRule="evenodd"
 clipRule="evenodd"
 strokeLinejoin="round"
 strokeMiterlimit={2}
 style={{'--as-1-ZqjLln': alignSelf,'--mt-2-ZqjLln': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZqjLln': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZqjLln': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZqjLln': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZqjLln': opacity,'--w-10-ZqjLln': typeof width === 'number' ? `${width}px` : width,'--h-11-ZqjLln': typeof height === 'number' ? `${height}px` : height,'--a-7-ZqjLln': isAnimated ? animation : "none",'--sd-8-ZqjLln': isAnimated ? strokeDashoffset : 0,'--sd-9-ZqjLln': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="CreditCardAmex.SvgPath"
  data-view-path={viewPath}
 d="M-20.2-17.6h288v74h-288z"
 style={{'--f-12-ZqjLln': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="CreditCardAmex.SvgPath:1"
  data-view-path={viewPath}
 d="M0 0h41.4v41.4H0z"
 style={{'--f-12-ZqjLln': fill}}
 className={`views-block ${styles.SvgPath1}`}
/>
<path
  data-testid="CreditCardAmex.SvgPath:2"
  data-view-path={viewPath}
 d="M39.9 29.3H26.2l-.9-1.1v1.1h-3v-1.8c-.4.1-.8.2-1.3.2h-.5v1.6h-4.4l-.7-.9-.6.9H7.7v-6.9h7.1l.7.9.7-.9h25.1V0H0v16.8l1.4-3.4h2.9l.7 1.7v-1.7h3.5l.5 1.4.5-1.4h15.2v.6c.6-.4 1.3-.6 2.1-.6h4.7l.7 1.7v-1.7H35l.8 1.3v-1.3h3v7h-3l-.8-1.2v1.2h-4.2l-.4-1h-.9l-.4 1h-2.5c-.7 0-1.4-.1-2-.6v.6h-4.3l-.9-1.1v1.1H3.7l-.4-1h-.9l-.4 1H0v21.1h41.4V28.8c-.4.3-.9.5-1.5.5z"
 fillRule="nonzero"
 style={{'--f-12-ZqjLln': fill3}}
 className={`views-block ${styles.SvgPath2}`}
/>
<path
  data-testid="CreditCardAmex.SvgPath:3"
  data-view-path={viewPath}
 d="M12.9 24.5v-1.1h-4v4.9h4v-1.1h-2.7v-.8h2.6v-1.1h-2.7v-.8h2.8zm3.9 3.8h1.6l-2-2.5 2-2.4h-1.6l-1.2 1.5-1.1-1.5h-1.6l2 2.4-1.9 2.4h1.5l1.2-1.5 1.1 1.6zm1.7-4.9v4.9h1.2v-1.6h1.5c1.1 0 1.7-.7 1.7-1.6 0-1-.6-1.6-1.7-1.6h-2.7v-.1zm3.1 1.7c0 .3-.2.5-.6.5h-1.4v-1.1H21c.5 0 .6.3.6.6m3.1 1.5h.5l1.5 1.7h1.5l-1.6-1.8c.8-.2 1.3-.8 1.3-1.5 0-.9-.6-1.6-1.7-1.6h-2.7v4.9h1.2v-1.7zm1.3-2.1c.4 0 .6.2.6.5s-.2.5-.6.5h-1.3v-1H26zm6.3 0v-1.1h-4v4.9h4v-1.1h-2.7v-.8h2.7v-1.1h-2.7v-.8h2.7zm3.1 2.7h-2.5v1.1h2.5c1.1 0 1.7-.6 1.7-1.6 0-.9-.6-1.4-1.5-1.4h-1.2c-.3 0-.4-.2-.4-.4s.2-.4.4-.4h2.1l.5-1.1h-2.6c-1.1 0-1.7.6-1.7 1.5s.6 1.5 1.5 1.5h1.2c.3 0 .4.2.4.4s-.2.4-.4.4m4.5 0h-2.5v1.1h2.5c1.1 0 1.7-.6 1.7-1.6 0-.9-.6-1.4-1.5-1.4h-1.2c-.3 0-.4-.2-.4-.4s.2-.4.4-.4H41l.5-1.1h-2.6c-1.1 0-1.7.6-1.7 1.5s.6 1.5 1.5 1.5h1.2c.3 0 .4.2.4.4s-.2.4-.4.4M4.4 19.4h1.4l-2.1-4.9H2.1L0 19.4h1.4l.4-1H4l.4 1zm-2.2-2.1l.7-1.7.7 1.7H2.2zm6.2 2.1h1.1l1.3-3.6v3.6H12v-4.9h-2l-1.1 3.1-1.1-3.1h-2v4.9H7v-3.6l1.4 3.6zm8.4-3.8v-1.1h-4v4.9h4v-1.1h-2.7v-.9h2.7v-1h-2.7v-.8h2.7zm2 2h.5l1.5 1.7h1.5l-1.6-1.8c.8-.2 1.3-.8 1.3-1.5 0-.9-.6-1.6-1.7-1.6h-2.7v5h1.2v-1.8zm1.3-2c.4 0 .6.2.6.5s-.2.5-.6.5h-1.3v-1h1.3zm2.3 3.8h1.2v-4.8h-1.2v4.8zm4.1 0l.6-1.1h-.4c-.8 0-1.2-.5-1.2-1.3v-.1c0-.7.4-1.3 1.2-1.3H28v-1.1h-1.4c-1.5 0-2.4 1-2.4 2.4v.1c.1 1.5.9 2.4 2.3 2.4m5.1 0H33l-2.1-4.9h-1.6l-2.1 4.9h1.4l.4-1h2.2l.4 1zm-2.2-2.1l.7-1.7.7 1.7h-1.4zm6.9 2.1h1.5v-4.9h-1.2v3l-1.9-3h-1.6v4.9h1.2v-3.1l2 3.1z"
 fillRule="nonzero"
 style={{'--f-12-ZqjLln': fill3}}
 className={`views-block ${styles.SvgPath3}`}
/>
</svg>
{children}
</React.Fragment>)
}